import React from 'react';

interface TemplatesTableErrorProps {
  error: unknown;
}

export const TemplatesTableError: React.FC<TemplatesTableErrorProps> = ({ error }) => {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="text-center">
        <div className="text-red-600 font-medium">Error loading templates</div>
        <div className="text-gray-500 text-sm mt-1">
          {error instanceof Error ? error.message : 'An unexpected error occurred'}
        </div>
      </div>
    </div>
  );
};
